import { objectToFrontEndFormat } from '@/services/ObjectFormatter'
import responseFormat from '../json_formats/ProductFormat'
import store from '../../../store/store.js'
import { cloneDeep } from 'lodash'

const initQuantity = product => {
    if (!product.quantity) product.quantity = 1
    return product
}

const isQuotation = () =>
    store.getters['TransactionModule/activeTransaction']
        ? store.getters['TransactionModule/activeTransaction'].id === 3
        : null

const initDiscount = product => {
    if (!product.lineDiscount)
        product.lineDiscount = {
            percentage_discount: null,
            unit_price_discount: null,
        }
    return product
}

const addQuantity = product => {
    return initDiscount(initQuantity(product))
}

const formatPrice = product => {
    if (
        // store.getters['AuthModule/isGroundSeller'] ||
        store.getters['AuthModule/isCallCenter']
    ) {
        product.virtual_offer_price = null
        product.sl_wholesale_discounts = []
    }
    if (!product.base_price && product.sale_prices.length > 0) {
        const OFFICE = store.getters['AuthModule/branchOfficeID'] || null
        product.base_price = product.sale_prices.find(
            s => s.branch_office_id === OFFICE
        ).sale_price
    }
    if (product.sale_price) product.sale_price = parseInt(product.sale_price)
    product.charge_percentage = store.getters['CustomerModule/chargePercentage']
    if (product.replaced_price && product.sale_price) {
        return product
    }
    if (
        product.virtual_offer_price &&
        product.virtual_offer_price.offer_price
    ) {
        product.sale_price = parseInt(product.virtual_offer_price.offer_price)
        product.isOffer = true
        if (product.charge_percentage)
            product.sale_price = Math.round(
                product.sale_price *
                    (1 + parseFloat(product.charge_percentage) / 100)
            )
        return product
    }
    if (product.sale_prices && product.sale_prices.length > 0) {
        const OFFICE = store.getters['AuthModule/branchOfficeID'] || null
        product.sale_price = product.sale_prices.find(
            s => s.branch_office_id === OFFICE
        ).sale_price
    }
    if (product.charge_percentage)
        product.sale_price = Math.round(
            product.sale_price *
                (1 + parseFloat(product.charge_percentage) / 100)
        )
    return product
}

const formatPricesInArray = productsArray => {
    productsArray = productsArray.map(product => {
        return formatPrice(product)
    })
    return productsArray
}

const formatUPC = product => {
    if (product.wh_product_upc_code && product.wh_product_upc_code.length > 0) {
        product.upc_code = product.wh_product_upc_code[0].upc_code
    }
    return product
}

const formatStock = product => {
    if (product.active_warehouse) return product
    if (product.stocks && product.stocks.length) {
        const OFFICE = store.getters['AuthModule/branchOfficeID'] || null
        /*
        product.stocks = product.stocks.map(s => {
            s.wh_warehouses = s.wh_warehouses.filter(
                w => w.wh_warehouse_type_id === 5
            )
            return s
        })
        */
        let office = product.stocks.find(s => s.g_branch_office_id === OFFICE)
        if (!office || !office.wh_warehouses || !office.wh_warehouses.length) {
            product.stocks = [
                {
                    g_branch_office_id: OFFICE,
                    wh_warehouses: [
                        {
                            wh_warehouse_name: 'sin stock',
                            logical_stock: 0,
                            wh_warehouse_type_id: 5,
                            wh_warehouse_id: 0,
                        },
                    ],
                },
            ]
            office = product.stocks[0]
        }
        let wh = office.wh_warehouses.find(
            w => w.logical_stock > 0 && w.wh_warehouse_type_id === 5
        )
        if (!wh) wh = office.wh_warehouses.find(w => w.logical_stock > 0)
        if (!wh) wh = office.wh_warehouses[0].wh_warehouse_id
        product.stock = wh.logical_stock
        product.total_branch_office_stock = office.wh_warehouses.reduce(
            (stock, wh) => (stock += wh.logical_stock),
            0
        )
        product.active_warehouse = wh.wh_warehouse_id
        if (!product.default_warehouse) {
            product.default_warehouse = wh.wh_warehouse_id
        }
        // Use all warehouses for this office's stock on call center
        if (store.getters['AuthModule/isCallCenter']) {
            product.stock = product.total_branch_office_stock
        }
        if (
            product.quantity &&
            product.quantity >
                (store.getters['AuthModule/isGroundSeller']
                    ? product.total_branch_office_stock
                    : product.stock) &&
            !isQuotation()
        )
            product.quantity = 0
        return product
    }
}

const formatStocksInArray = productsArray => {
    productsArray = productsArray.map(product => {
        return formatStock(product)
    })
    return productsArray
}

const frontendProduct = (product, activeTransactionID = 0) => {
    product = objectToFrontEndFormat(
        formatUPC(formatStock(formatPrice(product))),
        responseFormat
    )
    product = addSaleProperties(product, activeTransactionID)
    if (
        product.replaced_price &&
        product.replaced_price.original_price == product.sale_price
    )
        delete product.replaced_price
    return product
}

const frontendProductsArray = (productsArray, activeTransactionID = 0) => {
    return productsArray.map(item => frontendProduct(item, activeTransactionID))
}

const calcWholesaleDiscount = product => {
    /*
    if (
        product.replaced_price &&
        product.replaced_price.replaced &&
        !product.customer_charge
    ) {
        delete product.discounted_price
        return product
    }
    */
    if (!product.quantity || !product.wholesaleDiscounts) return product
    const OFFICE = store.getters['AuthModule/branchOfficeID'] || null
    const available_discounts = product.wholesaleDiscounts
        .filter(item => item.g_branch_office_id === OFFICE)
        .sort((a, b) => {
            if (a.quantity_discount < b.quantity_discount) return 1
            if (a.quantity_discount > b.quantity_discount) return -1
            return 0
        })
    if (available_discounts) {
        product.availableWholesaleDiscounts = available_discounts
    } else {
        delete product.available_discounts
    }
    const discount = available_discounts.find(
        item => item.quantity_discount <= product.quantity
    )
    if (product.virtual_offer_price && product.virtual_offer_price.offer_price)
        return product
    if (discount) {
        let discountAmount = discount.unit_price_discount
        let invoiceDiscountAmount = discount.unit_price_discount
        if (!discountAmount || discountAmount == 0) {
            discountAmount = truncateAndRound(
                (product.sale_price * discount.percentage_discount) / 100
            )
            invoiceDiscountAmount = truncateAndRound(
                (product.sale_price * discount.percentage_discount) / 100
            )
        }
        if (product.replaced_price && product.replaced_price.replaced) {
            product.replaced_price.original =
                product.base_price - discountAmount
        } else {
            product.discounted_price = product.sale_price - discountAmount
            product.backend_invoice_price = truncateAndRound(
                product.sale_price - invoiceDiscountAmount
            )
            product.active_discount = discount
        }
    } else {
        delete product.discounted_price
        delete product.active_discount
        delete product.backend_invoice_price
    }
    // if (product.charge_percentage)
    //     product.replaced_price = Math.round(
    //         product.discounted_price *
    //             (1 + parseFloat(product.charge_percentage) / 100)
    //     )
    return product
}

const calcLineDiscounts = product => {
    if (
        !product.replaced_price &&
        (!product.lineDiscount ||
            (!product.lineDiscount.percentage_discount &&
                !product.lineDiscount.unit_price_discount)) &&
        product.virtual_offer_price &&
        product.virtual_offer_price.offer_price
    ) {
        let unit_price_discount =
            (parseInt(product.virtual_offer_price.sale_price) -
                parseInt(product.virtual_offer_price.offer_price)) *
            product.quantity
        let price = twoDecimalsFormat(
            parseInt(product.virtual_offer_price.sale_price) /
                (product.neto ? 1.19 : 1)
        )
        product.subtotal =
            truncateAndRound(price * product.quantity) -
            //neto aproximado a  2 decimales
            twoDecimalsFormat(unit_price_discount / (product.neto ? 1.19 : 1))
        if (product.altSubtotal)
            product.altSubtotal =
                parseInt(product.virtual_offer_price.sale_price) *
                    product.quantity -
                unit_price_discount
        return product
    }
    if (product.lineDiscount.percentage_discount != null) {
        let discount =
            (product.subtotal * product.lineDiscount.percentage_discount) / 100
        discount = Math.round(twoDecimalsFormat(discount))
        product.subtotal = product.subtotal - discount
        if (product.altSubtotal) {
            let altDiscount =
                (product.altSubtotal *
                    product.lineDiscount.percentage_discount) /
                100
            altDiscount = Math.round(twoDecimalsFormat(altDiscount))
            product.altSubtotal = product.altSubtotal - altDiscount
        }
        product.subtotal = twoDecimalsFormat(product.subtotal)
    }
    if (product.lineDiscount.unit_price_discount != null) {
        product.subtotal =
            truncateAndRound(product.subtotal) -
            //neto aproximado a  2 decimales
            twoDecimalsFormat(
                product.lineDiscount.unit_price_discount /
                    (product.neto ? 1.19 : 1)
            )
        if (product.altSubtotal)
            product.altSubtotal =
                product.altSubtotal - product.lineDiscount.unit_price_discount
    }
    return product
}

const calcSubTotal = product => {
    let price = product.sale_price
    if (product.discounted_price) price = product.discounted_price
    if (product.replaced_price) price = product.sale_price
    if (product.neto) price = product.neto
    product.subtotal = product.quantity * price
    /*
        (product.neto || product.replaced_price
            ? product.sale_price
            : product.discounted_price || product.sale_price)
            */
    if (product.neto) {
        let pr2 = JSON.parse(JSON.stringify(product))
        if (pr2.neto) delete pr2.neto
        pr2 = calcWholesaleDiscount(pr2)
        let price2 = product.sale_price
        if (product.discounted_price) price2 = product.discounted_price
        if (product.replaced_price) price2 = product.sale_price
        pr2.subtotal = pr2.quantity * price2
        /*
            (pr2.replaced_price
                ? pr2.neto
                : pr2.discounted_price || pr2.sale_price)
                */
        product.altSubtotal = pr2.subtotal
        product.altPrice = price2
        /*
        pr2.replaced_price
            ? pr2.sale_price
            : pr2.discounted_price || pr2.sale_price
            */
    }
    product = calcLineDiscounts(product)
    // REDONDEAR AQUÍ SUBTOTALES
    product.subtotal = truncateAndRound(product.subtotal)
    if (product.altSubtotal)
        product.altSubtotal = truncateAndRound(product.altSubtotal)
    return product
}

const calcNeto = product => {
    let neto = product.sale_price / 1.19
    if (product.discounted_price && !product.replaced_price)
        neto = product.discounted_price / 1.19
    if (
        product.virtual_offer_price &&
        parseInt(product.sale_price) ===
            parseInt(product.virtual_offer_price.offer_price)
    ) {
        neto = product.virtual_offer_price.sale_price / 1.19
        console.log('asdf', neto)
    }
    //Calcular con 2 decimales, redondear sólo al calcular subtotal
    // product.neto = truncateAndRound(neto)
    product.neto = twoDecimalsFormat(neto)
    return product
}

/**
 * Formats an item pulled from database, giving it aditional properties related
 * to the SalePoint process.
 * @param {*} item
 */
const addSaleProperties = (item, activeTransactionID = 0) => {
    item = addQuantity(item)
    item = calcWholesaleDiscount(item)
    if ([2, 3].includes(activeTransactionID)) {
        item = calcNeto(item)
    } else {
        delete item.neto
    }
    item = calcSubTotal(item)
    return item
}

/*
        let price = twoDecimalsFormat(
            parseInt(product.virtual_offer_price.sale_price) /
                (product.neto ? 1.19 : 1)
        )
        */

const globalDiscount = (discount, total, isInvoice) => {
    if (
        !discount ||
        (!discount.percentage_discount && !discount.amount_discount)
    )
        return total
    if (discount.percentage_discount != null) {
        if (discount.percentage_discount >= 100)
            discount.percentage_discount = 99
        return total * ((100 - discount.percentage_discount) / 100)
    }
    if (discount.amount_discount != null) {
        if (discount.amount_discount > total)
            discount.amount_discount = total - 1
        return (
            total -
            Math.round(discount.amount_discount / (isInvoice ? 1.19 : 1))
        )
    }
}

const calcTotal = (items, discount) => {
    let total = 0
    items.forEach(item => {
        total += item.subtotal
    })
    let isInvoice = items.some(i => i.neto)
    return truncateAndRound(globalDiscount(discount, total, isInvoice))
}

const truncateAndRound = float => {
    float = ('' + float).split('.')
    if (float.length > 1) {
        float = float[0] + '.' + float[1].charAt(0)
    } else {
        float = float[0]
    }
    return Math.round(float)
}

const twoDecimalsFormat = float => {
    return Math.round(float * 100) / 100
}

export default {
    addSaleProperties,
    formatPrice,
    formatPricesInArray,
    formatStock,
    formatStocksInArray,
    frontendProduct,
    frontendProductsArray,
    calcNeto,
    calcSubTotal,
    calcWholesaleDiscount,
    truncateAndRound,
    addQuantity,
    globalDiscount,
    calcTotal,
}
